module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "associations-list"
  }, [_c('div', {
    staticClass: "association-box"
  }, [_c('div', {}, [_c('div', {
    staticClass: "btn-group donation-section",
    attrs: {
      "role": "group",
      "aria-label": "donation-section"
    }
  }, [_c('button', {
    class: 'btn btn-default' + (_vm.donationAmount == 200 ? ' active' : ''),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.donationAmount = 200
      }
    }
  }, [_vm._v("€ 2")]), _vm._v(" "), _c('button', {
    class: 'btn btn-default' + (_vm.donationAmount == 400 ? ' active' : ''),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.donationAmount = 400
      }
    }
  }, [_vm._v("€ 4")]), _vm._v(" "), _c('button', {
    class: 'btn btn-default' + (_vm.donationAmount == 600 ? ' active' : ''),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.donationAmount = 600
      }
    }
  }, [_vm._v("€ 6")]), _vm._v(" "), _c('button', {
    class: 'btn btn-default' + (_vm.donationAmount == 800 ? ' active' : ''),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.donationAmount = 800
      }
    }
  }, [_vm._v("€ 8")]), _vm._v(" "), _c('button', {
    class: 'btn btn-default' + (_vm.donationAmount == 1000 ? ' active' : ''),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.donationAmount = 1000
      }
    }
  }, [_vm._v("€ 10")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right donate-btn",
    attrs: {
      "disabled": _vm.donationAmount < 200,
      "type": "button",
      "name": "donate"
    },
    on: {
      "click": _vm.submitDonation
    }
  }, [_vm._v(_vm._s(_vm.$t('Donate')))])])]), _vm._v(" "), _c('img', {
    staticClass: "assoc-logo-large",
    attrs: {
      "src": _vm.assoc.logo_url,
      "alt": _vm.assoc.short_description
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.assoc.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.assoc.description))]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item",
    attrs: {
      "title": _vm.$t('address')
    }
  }, [_c('i', {
    staticClass: "fa fa-map fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "assoc-labels"
  }, [_vm._v(_vm._s(_vm.assoc.address))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item",
    attrs: {
      "title": _vm.$t('city')
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "assoc-labels"
  }, [_vm._v(_vm._s(_vm.assoc.city))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item",
    attrs: {
      "title": _vm.$t('twitter')
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "assoc-labels"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://twitter.com/' + _vm.assoc.twitter_username
    }
  }, [_vm._v("@" + _vm._s(_vm.assoc.twitter_username))])])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item",
    attrs: {
      "title": _vm.$t('Total Donations')
    }
  }, [_c('i', {
    staticClass: "fa fa-line-chart fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "assoc-labels"
  }, [_vm._v("€ " + _vm._s(_vm.assoc.total_donations / 100))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9cb96b52"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Association.vue
// module id = 316
// module chunks = 1